define('bindingHandlers/dateRangePicker',[
    'lib/lodash4',
    'lib/knockout',
    'jquery',
    'moment',
    'bindingHandlers/util/datePickerUtil',
    'util/keyCode',

    'lib/daterangepicker',
], function (_, ko, $, moment, datePickerUtil, keyCode) {

    'use strict';


    /**
     * Bootstraps' daterange picker seems to not account for daylight savings. For instance
     * when a user picks a date the UTC offset is not accurately reflected in the start and end date
     * for instance a selected date of 2014-11-03 is returned in a moment as: "2014-11-03T00:00:00-04:00"
     * instead of "2014-11-02T00:00:00-05:00" which is when DST ends and the UTC needs to be adjusted
     *
     * Note that this function does not alter the value of the moment it simply returns a new moment with the
     * same date time selected by the user and correct UTC.
     *
     * If the UTC does not need to be corrected than the same UTC will be returned.
     *
     * @param date - local time passed in a moment object - This needs to be local time to allow the format() to reset UTC
     * @returns moment with correct UTC
     */
    var adjustUtcOffset = function(date){
        if (_.isFunction(date.format)){
            var tmpFormat  = "YYYY-MM-DD hh:mm"; //Internal format to simply touch the moment which will cause it to reset the UTC.
            var dateString = date.format(tmpFormat);
            var tmpDate    = moment(dateString, tmpFormat, true);
            return tmpDate;
        }
        return date;
    };

    /**
     * The dateRangePicker binding handler is used for functionality that calls for
     * date selection by range.
     *
     * The input tag will need a specific class name to differentiate it from other date range pickers that may be
     * elsewhere on the page. A dropdown containing the date range picker will be created and appended before the end
     * of the body. A new dropdown will be created per instance and referenced using the class of the input tag.
     *
     * # Required
     * value {Observable} - String, will contain ISO 8601 date ranges
     *
     * # Optional
     * isTodayMaxDate {Boolean} - default: false; when true today will be the maximum date a user can select; prevents any future date
     *                            from being selected. Leaving false will allow a user to pick any date in the future
     * isYesterdayMaxDate {Boolean} - default: false; when true yesterday will be the maximum date a user can select; prevents today or
     *                            any future date from being selected. Leaving false will allow a user to pick any date in the future
     * showMonthYearDropdowns {Boolean} - default: false; when true it enables a dropdown selection of month and year. Leaving false will
     *                                    disable them
     * intervalSelection {Boolean} - default: false; true: shows predetermined ranges,
     *
     * minDateDuration: (default - false) - # of days ago that we support; example: 60 means user can select last 60 days
     *
     *
     * @example
     * Minimal example as input:
     *      <input class="classRelatedToParent" data-bind="
     *          dateRangePicker: {  value: dateRangeValue } "/>
     *
     * @example
     * Minimal example as div:
     *      <div class="someclassname" data-bind-"
     *           dateRangePicker: { value: dateRangeValue } ">
     *      </div>
     *
     * @example
     * Full Example with ranges and active month / year dropdowns
     *      <div class="someclassname" data-bind= "
     *          dateRangePicker: {
     *              options: {
     *                  intervalSelection: true,
     *                  showDropdowns: true,
     *                  isTodayMaxDate: true,
     *                  minDateDuration: 31
     *                  },
     *              value: dateRangeValue
     *          }
     *      "></div>
     *
     * @type {{init: init}}
     */


    ko.bindingHandlers.dateRangePicker = {
        init: function (element, valueAccessor) {
            /* -------
             Setup
             ---------*/
            var bindingData = ko.toJS(valueAccessor());
            if (bindingData.options){
                bindingData.options.useAsISO = true;
            } else {
                bindingData.options = {};
                bindingData.options.useAsISO = true;
            }

            var options = datePickerUtil.processOptions(bindingData);
            var value = ko.unwrap(bindingData.value);
            options.invalidRangeString = ko.i18n.renderString('widget.dateRangePicker.invalidInterval');

            /* ------------------
             Create dropdown
             --------------------- */
            $(element).daterangepicker(options, function (startDate, endDate) {
                startDate  = adjustUtcOffset(startDate);
                endDate    = adjustUtcOffset(endDate);

                startDate = datePickerUtil.formatForValue( moment(startDate).startOf('day') );

                // Using the beginning of the next day causes off by one errors in the display
                // of the picked dates.  Rather than fudging the date - useEndOfDay allows both means
                // of defining the end bounds to be available.
                endDate = moment(endDate);
                endDate = options.useEndOfDay ? endDate.endOf('day') : endDate.add(1, "days").startOf('day');
                endDate = datePickerUtil.formatForValue(endDate);
                if (startDate === 'Invalid date'){
                    startDate = ko.i18n.renderString("dateRangePicker.invalidDate");

                }
                if (endDate === 'Invalid date'){
                    endDate = ko.i18n.renderString("dateRangePicker.invalidDate");
                }

                valueAccessor().value(startDate + "/" + endDate);
            });

            if (value) {

                var startDateText = ko.i18n.formatDate(moment(options.startDate).toDate(), "L");
                var endDateText = ko.i18n.formatDate(moment(options.endDate).toDate(), "L");

                $(element).val(startDateText + " - " + endDateText);
            }

            // allow opening with keyboard
            if ($(element).is("div")) {
                $(element).attr("tabindex", "0");
                $(element).on('keypress', function(e) {
                    if (e.keyCode !== keyCode.SPACE && e.keyCode !== keyCode.ENTER) {
                        return;
                    }
                    if (e.keyCode === keyCode.SPACE) {
                        e.preventDefault();
                    } 

                    $(element).data('daterangepicker').toggle();
                    $(element).data('daterangepicker').container.find('.ranges .daterangepicker_start_input input').focus();
                });
            }

            datePickerUtil.modifyStyles(element);
            datePickerUtil.customizeCalendarHeader($(element).data('daterangepicker'));
            datePickerUtil.handleDisposal(element);
        }

    };
});

